import React, { useEffect, useState } from "react";
import { FormulasManagementTableRow } from "./formulasManagementTableRow";

export const FormulasManagementTable = ({
	data,
	setProductionFormulaToEdit,
	deleteProductionFormula,
	openModal,
	setModalAvialbe,
}) => {
	const [showData, setShowData] = useState(data);

	useEffect(() => {
		setShowData(data);
	}, [data]);

	function handleSearch(e) {
		if (e.target.value === "") {
			return setShowData(data);
		}
		setShowData(
			data.filter(
				(item) =>
					item.productionFormula.toLowerCase().includes(e.target.value) ||
					item.product.description.toLowerCase().includes(e.target.value) ||
					item.product.refInventory.toLowerCase().includes(e.target.value) ||
					item.status.toLowerCase().includes(e.target.value)
			)
		);
	}

	return (
		<div>
			<div className="document-search">
				<h2 className="title-search">Buscar</h2>
				<input
					type="search"
					name=""
					id=""
					onChange={handleSearch}
					className="search-box"
				/>
			</div>
			<h3 className="titulo1">Lista de Fórmulas de Producción</h3>
			<table className="tabla-procesos">
				<thead>
					<tr className="fila-tabla-procesos">
						<th className="titleTableDocuments03">Fecha</th>
						<th className="titleTableDocuments03">Fórmula de Producción</th>
						<th className="titleTableDocuments02">Producto</th>
						<th className="titleTableDocuments03">status</th>
						<th className="titleTableDocuments02">Componentes</th>
						<th className="titleTableDocuments03">Acción</th>
					</tr>
				</thead>
				<tbody>
					{showData.length > 0 ? (
						showData.map((el) => (
							<FormulasManagementTableRow
								key={el.id}
								el={el}
								setProductionFormulaToEdit={setProductionFormulaToEdit}
								openModal={openModal}
								setModalAvialbe={setModalAvialbe}
								deleteProductionFormula={deleteProductionFormula}
							/>
						))
					) : (
						<tr>
							<td colSpan="3">Sin datos</td>
						</tr>
					)}
				</tbody>
			</table>
		</div>
	);
};
